"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deal_info_types_1 = require("@wix/wix-vod-constants/dist/common/deal-info-types");
var lodash_1 = require("lodash");
function getMinPriceInfo(dealInfo) {
    var enabledDealInfo = (dealInfo || []).filter(function (d) { return d.enabled; });
    if (!enabledDealInfo.length) {
        return null;
    }
    return lodash_1.minBy(enabledDealInfo, 'price');
}
exports.getMinPriceInfo = getMinPriceInfo;
function hasEnabledPriceInfo(dealInfo) {
    return (dealInfo || []).some(function (d) { return d.enabled; });
}
exports.hasEnabledPriceInfo = hasEnabledPriceInfo;
function buildGetPriceInfo(type) {
    return function (dealInfo) {
        return (dealInfo || []).find(function (d) { return d.enabled && d.type === type; }) || null;
    };
}
exports.getSubscriptionPriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.SUBSCRIPTION);
exports.getSalePriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.SALE);
exports.getRentPriceInfo = buildGetPriceInfo(deal_info_types_1.DEAL_INFO_TYPES.RENT);
function getDealInfoByType(dealInfo, type) {
    switch (type) {
        case 'sale':
            return exports.getSalePriceInfo(dealInfo);
        case 'rent':
            return exports.getRentPriceInfo(dealInfo);
        case 'subscription':
            return exports.getSubscriptionPriceInfo(dealInfo);
        default:
            return {};
    }
}
exports.getDealInfoByType = getDealInfoByType;
//# sourceMappingURL=deal-info-helpers.js.map